import { useEffect, useState } from "react";

import { getSessionDetails } from "../../api/auth";
import { getCompany } from "../../api/company";

export function useSession() {
  const [user, setUser] = useState(null);
  const [login, setLogin] = useState(false);

  useEffect(() => {
    async function fetchSession() {
      const { user } = await getSessionDetails();
      setUser(user);
    }

    fetchSession().catch(() => {
      console.log("error");
      setUser(null);
      setLogin(true);
    });
  }, []);

  return { user, login };
}

export function useSubscription() {
  const [subscribed, setSubscribed] = useState(true);

  useEffect(() => {
    async function fetchSession() {
      // Sending req to any route that's protected by subscription middleware
      await getCompany();
      setSubscribed(true);
    }

    fetchSession().catch((error) => {
      console.log(error)
      if (error.status === 403) {
        console.log("Not subscribed");
      }
      setSubscribed(false);
    });
  }, []);

  return { subscribed };
}

export async function redirectLogin() {
  window.location.href = "/login";
}


export async function logout() {
  localStorage.removeItem("token");
  redirectLogin();
}


